import LayoutManager from "../../../lib/html5-software-library/src/ranj/layout/LayoutManager";
import AbstractInstaller from "../app/core/AbstractInstaller";

export default class LayoutInstaller extends AbstractInstaller {


    constructor(injector, commands, mediatorMap) {
        super(injector, commands, mediatorMap);

        injector.mapClass("layoutManager", LayoutManager, true);
    }
}